module.exports = __webpack_public_path__ + "img/hk-header.c2856002.png";